import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { IEmailFormSlice, emailFormSliceCreator } from "./slices/emailFormSlice.ts";
import { ICardSMSFormSlice, cardSmsFormSliceCreator } from "./slices/cardSmsFormSliceCreator.ts";

export type CardIssuanceFormState = IEmailFormSlice & ICardSMSFormSlice;

export const useCardIssuanceFormStore = create<CardIssuanceFormState>()(
  devtools(
    (...a) => ({
      ...emailFormSliceCreator(...a),
      ...cardSmsFormSliceCreator(...a),
    }),
    { name: "card-issuance-store" },
  ),
);
